/* eslint-env browser */

/**
 * Gallery card support
 * Used on any individual post/page
 *
 * Detects when a gallery card has been used and applies sizing to make sure
 * the display matches what is seen in the editor.
 */ 

//Swiper MAIN
(function(){
var swiperMain = new Swiper(".swiper-main", {
    slidesPerView: 1,
    mousewheel: false,
    keyboard: false,
    allowTouchMove: false,
  })})();
//END MAIN Swiper 

//Swiper RECOMMEND
(function(){
var swiperRecommend = new Swiper(".swiper-recommend", {
    spaceBetween: 15,
    navigation: {
  nextEl: ".swiper-button-next",
  prevEl: ".swiper-button-prev",
},
    breakpoints: {
      320: {
        slidesPerView: 1.2,
      },
      390: {
        slidesPerView: 1.3,
      },
      420: {
        slidesPerView: 1.4,
      },
      440: {
        slidesPerView: 1.5,
      },
      490: {
        slidesPerView: 1.6,
      },
      520: {
        slidesPerView: 1.7,
      },
      550: {
        slidesPerView: 1.9,
      },
      600: {
        slidesPerView: 2.0,
      },
      640: {
        slidesPerView: 2.2,
      },
      720: {
        slidesPerView: 2.4,
      },
      768: {
        slidesPerView: 2.6,
      },
      769: {
        slidesPerView: 1.7,
      },
      820: {
        slidesPerView: 1.8,
      },
      880: {
        slidesPerView: 2,
      },
      920: {
        slidesPerView: 2.1,
      },
      1000: {
        slidesPerView: 2.3,
      },
      1080: {
        slidesPerView: 2.6,
      },
      1150: {
        slidesPerView: 2.7,
      },
      1240: {
        slidesPerView: 3.0,
      },
      1350: {
        slidesPerView: 3.3,
      },
      1440: {
        slidesPerView: 3.6,
      },
      1580: {
        slidesPerView: 4.1,
      },
    
    },
    mousewheel: false,
    keyboard: true,
  })})();
//END SLIDER
//Swiper POSTS
(function(){
  var swiperPosts = new Swiper(".swiper-posts", {
      spaceBetween: 40,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        590: {
          slidesPerView: 1,
        },
        640: {
          slidesPerView: 1,
        },
        890: {
          slidesPerView: 2,
        },
        1074: {
          slidesPerView: 2,
        },
        1340: {
          slidesPerView: 3,
        },
      },
      mousewheel: false,
      keyboard: true,
    })})();
  //END SLIDER
//HIDE SHOW MENUE
(function(){
const navMenue = document.getElementById("hideNav");
const subscribeButton = document.getElementById("subscribeBtn");
const refaceBlogTxt =  document.getElementById("refaceBlog");
window.addEventListener("scroll", () => {
    if (window.scrollY > 0 && window.scrollY < 50) {
        navMenue.classList.add("hide-nav");
        subscribeButton.classList.add("hide-nav");
        refaceBlogTxt.classList.remove("gh-reface-blog-hide");
        refaceBlogTxt.classList.add("gh-reface-blog");
    }else if(window.scrollY === 0){
        navMenue.classList.remove("hide-nav");
        subscribeButton.classList.remove("hide-nav");
        refaceBlogTxt.classList.add("gh-reface-blog-hide");
        refaceBlogTxt.classList.remove("gh-reface-blog");
    }
});

})();
//END HIDE SHOW MENUE

//NAV ACTIVE CLIC
(function (){
    const currentUrl = window.location.pathname ;
    if(currentUrl === "/"){
        document.getElementById("tag-main").classList.add("active-tag")
    }
    if(currentUrl === "/tag/newz/"){
        document.getElementById("tag-new").classList.add("active-tag")
    }
    if(currentUrl === "/tag/biz/"){
        document.getElementById("tag-biz").classList.add("active-tag")
    }
    if(currentUrl === "/tag/art-fun/"){
        document.getElementById("tag-fun").classList.add("active-tag")
    }
})();
//NAV ACTIVE CLIC

(function (window, document) {
    var resizeImagesInGalleries = function resizeImagesInGalleries() {
        var images = document.querySelectorAll('.kg-gallery-image img');
        images.forEach(function (image) {
            var container = image.closest('.kg-gallery-image');
            var width = image.attributes.width.value;
            var height = image.attributes.height.value;
            var ratio = width / height;
            container.style.flex = ratio + ' 1 0%';
        });
    };

    document.addEventListener('DOMContentLoaded', resizeImagesInGalleries);
})(window, document);

(function () {
    const mediaQuery = window.matchMedia('(max-width: 767px)');

    const head = document.querySelector('.gh-head');
    const menu = head.querySelector('.gh-head-menu');
    const nav = menu.querySelector('.nav');
    if (!nav) return;

    const logo = document.querySelector('.gh-head-logo');
    const navHTML = nav.innerHTML;

    if (mediaQuery.matches) {
        const items = nav.querySelectorAll('li');
        items.forEach(function (item, index) {
            item.style.transitionDelay = 0.03 * (index + 1) + 's';
        });
    }

    const makeDropdown = function () {
        if (mediaQuery.matches) return;
        const submenuItems = [];

        while ((nav.offsetWidth + 64) > menu.offsetWidth) {
            if (nav.lastElementChild) {
                submenuItems.unshift(nav.lastElementChild);
                nav.lastElementChild.remove();
            } else {
                return;
            }
        }

        if (!submenuItems.length) {
            document.body.classList.add('is-dropdown-loaded');
            return;
        }

        const toggle = document.createElement('button');
        toggle.setAttribute('class', 'nav-more-toggle');
        toggle.setAttribute('aria-label', 'More');
        toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor"><path d="M21.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM13.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM5.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0z"></path></svg>';

        const wrapper = document.createElement('div');
        wrapper.setAttribute('class', 'gh-dropdown');

        if (submenuItems.length >= 10) {
            document.body.classList.add('is-dropdown-mega');
            wrapper.style.gridTemplateRows = 'repeat(' + Math.ceil(submenuItems.length / 2) + ', 1fr)';
        } else {
            document.body.classList.remove('is-dropdown-mega');
        }

        submenuItems.forEach(function (child) {
            wrapper.appendChild(child);
        });

        toggle.appendChild(wrapper);
        nav.appendChild(toggle);

        document.body.classList.add('is-dropdown-loaded');

        toggle.addEventListener('click', function () {
            document.body.classList.toggle('is-dropdown-open');
        });

        window.addEventListener('click', function (e) {
            if (!toggle.contains(e.target) && document.body.classList.contains('is-dropdown-open')) {
                document.body.classList.remove('is-dropdown-open');
            }
        });
    }

    imagesLoaded(head, function () {
        makeDropdown();
    });

    window.addEventListener('resize', function () {
        setTimeout(function () {
            nav.innerHTML = navHTML;
            makeDropdown();
        }, 1);
    });
})();